<template>
  <ContainerArea class="BrowseDashboard">
    <LayoutFill :no-gutters="solidHeader" :no-padding="solidHeader">
      <MainBanner :title="browseTitle" :solid-header="solidHeader" />
    </LayoutFill>
    <LayoutGutters>
      <BrowseGroups
        v-if="browseSubjects"
        :groups="subjectSummaries | sortedCaseInsensitive('name')"
      />
      <BrowseGroups
        v-if="browseCategories"
        :groups="categorySummaries | sortedCaseInsensitive('name')"
      />
    </LayoutGutters>
  </ContainerArea>
</template>

<script>
import { mapState } from "vuex";
import buildActionDispatcher from "~/actions/utilities/buildActionDispatcher";

import ContainerArea from "~/components/layout/ContainerArea";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";

import MainBanner from "~/components/banner/MainBanner.vue";
import BrowseGroups from "~/components/groups/BrowseGroups.vue";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";
import toCanonicalUrl from "~/plugins/utilities/toCanonicalUrl.js";

export default {
  name: "BrowseDashboard",
  components: {
    ContainerArea,
    LayoutGutters,
    LayoutFill,
    MainBanner,
    BrowseGroups,
  },
  fetch: buildActionDispatcher("loadBrowseDashboard"),
  head() {
    const { browseTitle, siteName, domain, partner } = this;

    const title = getPageTitle(siteName);

    const pageTitle = browseTitle + " | " + title;
    const canonicalUrl = toCanonicalUrl(`browse-dashboard`, partner);
    const cupTechText =
      this.partner === "chemrxiv"
        ? "technology provided by"
        : "brought to you by";

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `Browse categories to discover early research outputs in ${domain} on ${siteName}, ${cupTechText} Cambridge University Press.`,
        },
      ],
      link: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  computed: {
    ...mapState({
      theme: (state) => state.theme,
      layout: (state) => state.theme.layout,
      subjectSummaries: (state) => state.currentOrigin.subjectSummaries,
      categorySummaries: (state) => state.currentOrigin.categorySummaries,
      siteName: (state) => getSiteName(state.theme),
      domain: (state) => state.theme.domain,
    }),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    browseSubjects() {
      return this.theme.browse?.subjects;
    },
    browseCategories() {
      return this.theme.browse?.categories;
    },
    browseBoth() {
      return this.browseSubjects && this.browseCategories;
    },
    browseTitle() {
      let title = "Browse";

      if (this.browseSubjects) {
        title += " Subjects";
      }
      if (this.browseBoth) {
        title += " &";
      }
      if (this.browseCategories) {
        title += " Categories";
      }

      return title;
    },
  },
};
</script>
